<div class="flag-container" *ngIf="!showForm">
    <!-- Logo at the top -->
    <div class="logo-container">
        <img class="uiUncollapsedLogoLanguage" src="../../assets/logo-light.png"
            alt="logo">
    </div>

    <h1 style="color: black;">{{ 'selectLanguage' | translate }} :</h1>
    <!-- Flags centered below the logo -->
    <div class="flags-container">
        <!-- Italy Flag (SVG from assets) -->
        <div style="display: none;" class="flag" (click)="selectFlag('it')">
            <img src="../../assets/icons/it.svg" alt="IT">
        </div>

        <!-- UK Flag (SVG from assets) -->
        <div class="flag" (click)="selectFlag('en')">
            <img src="../../assets/icons/en.svg" alt="EN">
        </div>
    </div>
</div>

<div *ngIf="showForm">
    <!-- Progress Bar -->
    <nz-progress class="progress-bar"
        [nzPercent]="progress"
        [nzStrokeWidth]="10"
        [nzShowInfo]="false"
        [nzStatus]="'active'"></nz-progress>

    <!-- Step 1: Name & Surname -->
    <div *ngIf="currentStep === 0">
        <form [formGroup]="stepForm('step1')" (ngSubmit)="nextStep()">
            <img class="uiUncollapsedLogo" src="../../assets/logo-light.png"
                alt="logo">

            <label for="name">
                {{ 'nameRegister' | translate }} <span class="required">*</span>
            </label>
            <input nz-input id="name" formControlName="name" type="text"
                (input)="sanitizeInput('step1.name')">
            <div
                *ngIf="stepForm('step1').get('name')?.invalid && stepForm('step1').get('name')?.touched"
                class="error">
                {{ 'fieldRequired' | translate }}
            </div>

            <label for="surname">
                {{ 'surnameRegister' | translate }} <span
                    class="required">*</span>
            </label>
            <input nz-input id="surname" formControlName="surname" type="text"
                (input)="sanitizeInput('step1.surname')">
            <div
                *ngIf="stepForm('step1').get('surname')?.invalid && stepForm('step1').get('surname')?.touched"
                class="error">
                {{ 'fieldRequired' | translate }}
            </div>

            <div class="step-navigation">
                <button nz-button nzType="primary" type="submit"
                    style="margin: auto; width: 90%;"
                    [disabled]="stepForm('step1').invalid">{{ 'nextRegister' |
                    translate }}</button>
            </div>
        </form>
    </div>

    <!-- Step 2: Email & Birthday -->
    <div *ngIf="currentStep === 1">
        <form [formGroup]="stepForm('step2')" (ngSubmit)="nextStep()">
            <img class="uiUncollapsedLogo" src="../../assets/logo-light.png"
                alt="logo">

            <label for="email">
                {{ 'emailRegister' | translate }} <span
                    class="required">*</span>
            </label>
            <input nz-input id="email" formControlName="email" type="email"
                (input)="sanitizeInput('step2.email')">
            <div
                *ngIf="stepForm('step2').get('email')?.invalid && stepForm('step2').get('email')?.touched"
                class="error">
                {{ 'fieldRequired' | translate }}
            </div>

            <label for="emailConfirm">
                {{ 'emailConfirmRegister' | translate }} <span
                    class="required">*</span>
            </label>
            <input nz-input id="emailConfirm" formControlName="emailConfirm"
                type="email" (input)="sanitizeInput('step2.emailConfirm')">
            <div *ngIf="stepForm('step2').get('emailConfirm')?.touched"
                class="error">
                <!-- Show 'emailsDoNotMatch' if emails don't match -->
                <div
                    *ngIf="stepForm('step2').get('emailConfirm')?.value !== stepForm('step2').get('email')?.value">
                    {{ 'emailsDoNotMatch' | translate }}
                </div>
                <!-- Show 'fieldRequired' if the confirmation email is empty and the emails match -->
                <div
                    *ngIf="stepForm('step2').get('emailConfirm')?.invalid && stepForm('step2').get('emailConfirm')?.value === stepForm('step2').get('email')?.value">
                    {{ 'fieldRequired' | translate }}
                </div>
            </div>

            <div class="step-navigation">

                <button nz-button nzType="primary" type="submit"
                    style="width: 80%;"
                    (click)="onSubmitEmail()"
                    [disabled]="stepForm('step2').invalid || stepForm('step2').get('emailConfirm')?.value !== stepForm('step2').get('email')?.value">
                    {{ 'nextRegister' | translate }}
                </button>

                <button nz-button (click)="prevStep()" style="width: 12%;">
                    <i nz-icon nzType="arrow-left"></i>
                </button>
            </div>
        </form>
    </div>

    <!-- Step 3: Gender Selection -->
    <div *ngIf="currentStep === 2">

        <form [formGroup]="stepForm('step3')" (ngSubmit)="nextStep()">
            <img class="uiUncollapsedLogo" src="../../assets/logo-light.png"
                alt="logo">

            <label for="birthday">
                {{ 'birthdayRegister' | translate }} <span
                    class="required">*</span>
            </label>
            <input nz-input id="birthday" formControlName="birthday" type="date"
                (input)="sanitizeInput('step2.birthday')">
            <div
                *ngIf="stepForm('step2').get('birthday')?.invalid && stepForm('step2').get('birthday')?.touched"
                class="error">
                {{ 'fieldRequired' | translate }}
            </div>

            <div
                *ngIf="registrationForm.get('step3.birthday')?.invalid && registrationForm.get('step3.birthday')?.touched">
                {{ 'validAge' | translate }}
            </div>

            <label for="gender">
                {{ 'sessoRegister' | translate }} <span
                    class="required">*</span>
            </label>
            <nz-select id="gender" formControlName="gender"
                (ngModelChange)="sanitizeInput('step3.gender')">
                <nz-option *ngFor="let sesso of sessoList" [nzValue]="sesso"
                    [nzLabel]="sesso"></nz-option>
            </nz-select>
            <div
                *ngIf="stepForm('step3').get('gender')?.invalid && stepForm('step3').get('gender')?.touched"
                class="error">
                {{ 'fieldRequired' | translate }}
            </div>

            <div class="step-navigation">
                <button nz-button nzType="primary" type="submit"
                    style="width: 80%;"
                    (click)="onSubmitEmail()"
                    [disabled]="stepForm('step2').invalid || stepForm('step2').get('emailConfirm')?.value !== stepForm('step2').get('email')?.value">
                    {{ 'nextRegister' | translate }}
                </button>

                <button nz-button (click)="prevStep()" style="width: 12%;">
                    <i nz-icon nzType="arrow-left"></i>
                </button>
            </div>
        </form>
    </div>

    <!-- Step 4: Privacy -->
    <div *ngIf="currentStep === 3">
        <form [formGroup]="stepForm('step4')" (ngSubmit)="onSubmit()">
            <img class="uiUncollapsedLogo" src="../../assets/logo-light.png"
                alt="logo">

            <!-- Show privacy radio buttons only if they exist -->
            <div formArrayName="privacyCheckboxes"
                *ngIf="resultsPrivacy?.[0]?.checkbox">
                <h1>Privacy</h1>
                <a (click)="downloadFile(resultsPrivacy[0].allegato?.['ITA'])">
                    ({{ 'openPrivacy' | translate }})
                </a>

                <div
                    *ngFor="let optionCtrl of getPrivacyCheckboxesControls(); let i = index"
                    [formGroupName]="i">
                    <!-- Option description and radio buttons
                    <div *ngIf="!isRadioSelected[i]">
                        
                    -->
                    <div>
                        <hr>
                        <div>
                            {{ optionCtrl.get('testo')?.value }}
                            <nz-radio-group
                                class="radio-group-inline">
                                <label nz-radio [nzValue]="'Yes'"
                                    (click)="onRadioSelect(i, optionCtrl.get('accetto')?.value)">
                                    {{ optionCtrl.get('accetto')?.value }}
                                </label>
                                <label nz-radio [nzValue]="'No'"
                                    (click)="onRadioSelect(i, optionCtrl.get('non_accetto')?.value)">
                                    {{ optionCtrl.get('non_accetto')?.value }}
                                </label>
                            </nz-radio-group>
                            <!-- Show error if radio is required and not selected -->
                        </div>
                    </div>

                    <!-- 
                    <div *ngIf="isRadioSelected[i]" class="separator"
                        (click)="openOption(i)">
                        <span>{{ optionSelected[i] }}</span>
                        <div
                            *ngIf="getPrivacyControl(i, optionSelected[i] )"
                            class="error"
                            style="color: red;"
                            >
                            {{ 'fieldRequired' | translate }}
                        </div>
                    </div>
                    Separator and 'Checked ---' when a radio button is selected -->

                </div>
            </div>

            <!-- Show buttons if checkboxes don't exist or after the checkboxes -->
            <div class="step-navigation">
                <button
                    nz-button
                    nzType="primary"
                    type="submit"
                    style="width: 80%;"
                    [nzLoading]="loading">
                    {{  'startQuestionnaire'    | translate }}
                </button>

                <button nz-button (click)="prevStep()" style="width: 12%;">
                    <i nz-icon nzType="arrow-left"></i>
                </button>
            </div>
        </form>
    </div>

    <!-- Success Message -->
    <div *ngIf="currentStep === 4">
        <nz-result
            nzStatus="success"
            nzTitle="{{ 'compilationLinkSent' | translate }}"
            nzSubTitle="{{ 'compilationLinkMessage' | translate }}">
        </nz-result>
    </div>

</div>

<div class="waiter-overlay" *ngIf="loading">
    <div class="waiter">
        <span class="loader">
            <i class="loader-dot"></i>
            <i class="loader-dot"></i>
            <i class="loader-dot"></i>
            <i class="loader-dot"></i>
        </span>
    </div>
</div>
